import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription, map, of, interval } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import * as ExcelJS from 'exceljs';
import * as fs from 'file-saver'; // Importe a biblioteca file-saver
import { Location } from '../../app/interfaces';
import { format, parseISO } from 'date-fns';


@Component({
  selector: 'app-time-table-interplantas',
  templateUrl: './time-table-interplantas.component.html',
  styleUrls: ['./time-table-interplantas.component.css'],
  standalone: false
})
export class TimeTableInterplantasComponent {
  argentina!: any[];
  item: any = {
    ID: '',
    local: '',
    contato: '',
    endereco: '',
    latitude: '',
    longitude: '',
    descarga: false
  };
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  tableNameLocation: string = 'Fornecedores_Karrara_Transport';
  query: string = 'Itens_Jetta';
  query2: string = 'Carriers';
  queryVeiculosLab: string = 'veiculos_lab_Karrara'
  query3: string = 'tipos_Veiculos_Karrara';
  query4: string = 'items_Excel_Karrara';
  queryVW: string = 'items_Operacao_VW';
  queryInterplantas: string = 'Operacao_Interplantas_Karrara';
  queryTimeTable: string = 'janelasTimeTable';
  queryChegadasLCB: string = 'ChegadasNoLCB';
  queryDiretasExtrasLCB: string = "Viagens-LCB-Diretas-Extras";
  queryDiretasLCB: string = "Viagens-Diretas-Planilha";
  data: any;
  base: number = 3;
  ID: number = Date.now();
  local: string = "";
  contato: string = "";
  endereco: string = "";
  comentario: string = "";
  dialogRef: any;
  items: any[] = [];
  totalMR: any[] = [];
  totalMRSemArg: any[] = [];
  itemsSP: any[] = [];
  itemsSul: any[] = [];
  itemsArg: any[] = [];
  itemsInterplantas: any[] = [];
  itemsInterplantasNaoFinalizados: any[] = [];
  itemsSPFinalizados: any[] = [];
  itemsSulFinalizados: any[] = [];
  itemsArgNaoFinalizados: any[] = [];
  totalMRFinalizado: any[] = [];
  name!: string;
  dialogOpen = false;
  dialogTiposOpen = false;
  carrier!: any[];
  veiculos!: any[];
  teste!: boolean;
  startDate!: string;
  endDate!: string;
  milkRunSP: boolean = true;
  milkRunSul: boolean = true;
  milkRunArg: boolean = true;
  filteredItems!: any[];
  interplantas: any[] = [];
  filteredInterplantas: any[] = [];
  naoTerminadas: any[] = [];
  distanciaTotal: number = 0;
  pesoTotal: number = 0;
  pesoTotalInterplantas: number = 0;
  usuarioLogado!: UsuarioLogado;
  isCarrierTCMEnabled: boolean = true;
  isCarrierJSLEnabled: boolean = true;
  isCarrierJSLVWEnabled: boolean = true;
  isCarrierLOTSEnabled: boolean = true;
  isCarrierJSLARGEnabled: boolean = true;
  isCarrierEnabled: boolean = true;
  subscription: Subscription | undefined;
  hoje = new Date();
  dataFiltra2Dias!: string;
  dataFiltraInterplantas!: string;
  dataFiltraSul!: string;
  dataFiltraArg!: string;
  objFillingRate: number = 85;
  classFillingRate: string = "";
  objVeiculosGrandes: number = 90;
  classVeiculosGrandes: string = "";
  objJanelas: number = 90;
  classJanelas: string = "";
  objMR!: number;
  classMR: string = "";
  objInterplantas!: number;
  classInterplantas: string = "";
  viagensInterplantasFinalizadas!: any[];
  localNumber!: number;
  propertyName!: string;
  viagensInterplantasTerminadas!: any[];
  viagensInterplantasTerminadasNumero!: number;
  pesoTotalTransportadoMR!: number;
  valorTotalTransportadoMR: number = 0;
  totalCostMR!: number;
  MRtotalizado!: number;
  qtdVeiculosGD!: number;
  totalEmissao!: number;
  tolerancia: number = 0.1; // 10%
  eficiencia!: number;
  porcentagemPontual!: number;
  porcentagemAtrasado!: number;
  porcentagemTotal!: number;
  classJanelasPontual!: string;
  classJanelasAtrasada!: string;
  classJanelasTotal!: string;
  totalMRDeveriaFinalizar!: number;
  totalJanelasInterplantasObj!: number;
  searchText: string = 'All';
  viagensInterplantasNaoTerminadas!: any[];
  filterColumnDados: string = 'dataPainel';
  filterColumnOperacao: string = 'Janela';
  referenceDate!: string;
  numDays: number = 2;
  numDays5: number = 5;
  porcentagemPontualColeta!: number;
  porcentagemPontualEntrega!: number;
  porcentagemColetaPontual!: number;
  porcentagemColetaAtrasado!: number;
  porcentagemColetaTotal!: number;
  porcentagemEntregaPontual!: number;
  porcentagemEntregaAtrasado!: number;
  porcentagemEntregaTotal!: number;
  classJanelasColeta!: string;
  classJanelasEntrega!: string;
  valorUmColeta!: number;
  valorDoisColeta!: number;
  valorUmEntrega!: number;
  valorDoisEntrega!: number;
  totalJanelasValidasColeta!: number;
  totalJanelasValidasEntrega!: number;
  altura: number = 10;
  largura: number = 10;
  labels = ["02:00", "Realizadas", "Planejadas"];
  sortColumn: string = '';
  mergedData: any[] = []; // Definir explicitamente o tipo como any[]
  sortDirection: number = 1;
  RECCONT: boolean = true;
  EXP: boolean = false;
  INT: boolean = false;
  EMB: boolean = false;
  RECSIDER: boolean = true;
  timeTableExcesso: any[] = [];
  corJanela: string = '';
  atrasado: boolean = false;
  editMode = false;
  editedValue: any;
  filterColumn: string = 'date';
  editJanelaDestino1!: string;
  editJanelaDestino2!: string;
  editJanelaDestino3!: string;
  editJanelaDestino4!: string;
  itemSelecionado: any;
  dataExibirPre: Date = new Date();
  dataExibir: Date = new Date();

  timeTable00 = this.createPlacaData();
  timeTable01 = this.createPlacaData();
  timeTable02 = this.createPlacaData();
  timeTable03 = this.createPlacaData();
  timeTable04 = this.createPlacaData();
  timeTable05 = this.createPlacaData();
  timeTable06 = this.createPlacaData();
  timeTable07 = this.createPlacaData();
  timeTable08 = this.createPlacaData();
  timeTable09 = this.createPlacaData();
  timeTable10 = this.createPlacaData();
  timeTable11 = this.createPlacaData();
  timeTable12 = this.createPlacaData();
  timeTable13 = this.createPlacaData();
  timeTable14 = this.createPlacaData();
  timeTable15 = this.createPlacaData();
  timeTable16 = this.createPlacaData();
  timeTable17 = this.createPlacaData();
  timeTable18 = this.createPlacaData();
  timeTable19 = this.createPlacaData();
  timeTable20 = this.createPlacaData();
  timeTable21 = this.createPlacaData();
  timeTable22 = this.createPlacaData();
  timeTable23 = this.createPlacaData();
  timeTable24 = this.createPlacaData();

  timeTableGeral: { [key: string]: any[] }[] = [this.timeTable00, this.timeTable01, this.timeTable02, this.timeTable03, this.timeTable04, this.timeTable05,
  this.timeTable06, this.timeTable07, this.timeTable08, this.timeTable09, this.timeTable10, this.timeTable11, this.timeTable12, this.timeTable13, this.timeTable14, this.timeTable15
    , this.timeTable16, this.timeTable17, this.timeTable18, this.timeTable19, this.timeTable20, this.timeTable21, this.timeTable22, this.timeTable23, this.timeTable24];


  itemsVW!: any[];
  itemsVWNaoFinalizados!: any[];
  isLoading: boolean = false;
  itemsSPFinalizados2!: any[];
  janelaDestino: any;
  fornecedores!: any[];
  numDays15: number = 10;
  edit2: boolean = false;
  totalReservas!: any[];
  itemsReserva!: any[];
  classHora!: any[];
  totalItensJetta!: any[];
  totalReservasRECCONT!: any[];
  totalReservasRECSIDER!: any[];
  itemsChegadaLCB!: any[];
  objetosCorrespondentes!: any[];
  itemsContainers!: any[];
  atrasadoContainer: boolean = false;
  atrasadoRECSIDER: boolean = false;
  totalReservasEMB!: any[];
  totalReservasEMBMR!: any[];
  atrasadoEMB!: boolean;
  itemsContainersReuse!: any[];
  itemsMRColetaEmbalagem!: any[];
  totalReservasEXP!: any[];
  atrasadoEXP!: boolean;
  volumesTotais: any;
  // volumesTotais!: {'EMB':number, 'EXP':number, 'RECSIDER':number, 'INT':number, 'RECCONT':number }
  valorItemVolume: number[][] = new Array(25).fill([]).map(() => new Array(5).fill(0));
  itemsContainersPrev!: any[];
  array1Filtrado: any;
  array2Filtrado: any;
  locais!: any[];
  veiculosLab: any;
  locaisName!: any[];
  ataulPlate: any;
  atualPlate: any;
  filtroacionado: boolean = false;
  totalCont: any[] = [];
  dataJanelaDestino2Alterada!: string;
  horaJanelaDestino2Alterada!: string;
  dataJanelaDestino3Alterada: any;
  horaJanelaDestino3Alterada: any;
  campoTocado: boolean = false;
  opcoesMotivo = [
    { valor: 0, descricao: "-" },
    { valor: 1, descricao: "Atraso no transporte/Transportadora" },
    { valor: 2, descricao: "Atraso no fornecedor" },
    { valor: 3, descricao: "Atraso no recebimento/SCANIA" },
    { valor: 4, descricao: "Atraso no recebimento/LCB" },
    { valor: 5, descricao: "Excesso de veículos no mesmo horário" },
    { valor: 6, descricao: "Chegada antecipada" }
  ];
  timeTableExcessoFiltrados!: any[];
  EMBMR: any;

  constructor(
    public dialog: MatDialog,
    private dynamodbService: ApiService,
    private http: HttpClient, private cdr: ChangeDetectorRef,
    private servicoAutenticacao: AutenticacaoService,
    private router: Router,
    private datePipe: DatePipe
  ) {
    this.volumesTotais = {};
    this.itemsMRColetaEmbalagem = [];
  }

  async ngOnInit(): Promise<void> {
    this.isLoading = true;

    try {
      const today = new Date();
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, '0');
      const day = today.getDate().toString().padStart(2, '0');
      this.endDate = `${year}-${month}-${day}`;
      this.startDate = `${year}-${month}-${day}`;

      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 10);
      const sevenDaysAgoYear = sevenDaysAgo.getFullYear();
      const sevenDaysAgoMonth = (sevenDaysAgo.getMonth() + 1).toString().padStart(2, '0');
      const sevenDaysAgoDay = sevenDaysAgo.getDate().toString().padStart(2, '0');
      this.dataFiltraArg = `${sevenDaysAgoYear}-${sevenDaysAgoMonth}-${sevenDaysAgoDay}`;

      const twoDaysAgo = new Date(today);
      twoDaysAgo.setDate(today.getDate() - 1);
      const twoDaysAgoYear = twoDaysAgo.getFullYear();
      const twoDaysAgoMonth = (twoDaysAgo.getMonth() + 1).toString().padStart(2, '0');
      const twoDaysAgoDay = twoDaysAgo.getDate().toString().padStart(2, '0');
      this.dataFiltra2Dias = `${twoDaysAgoYear}-${twoDaysAgoMonth}-${twoDaysAgoDay}`;

      const threeDaysAgo = new Date(today);
      threeDaysAgo.setDate(today.getDate() - 3);
      const threeDaysAgoYear = threeDaysAgo.getFullYear();
      const threeDaysAgoMonth = (threeDaysAgo.getMonth() + 1).toString().padStart(2, '0');
      const threeDaysAgoDay = threeDaysAgo.getDate().toString().padStart(2, '0');
      this.dataFiltraSul = `${threeDaysAgoYear}-${threeDaysAgoMonth}-${threeDaysAgoDay}`;

      const diaAtual = new Date(today);
      diaAtual.setDate(today.getDate());
      const diaAtualYear = diaAtual.getFullYear();
      const diaAtualMonth = (diaAtual.getMonth() + 1).toString().padStart(2, '0');
      const diaAtualDay = diaAtual.getDate().toString().padStart(2, '0');
      this.dataFiltraInterplantas = `${diaAtualYear}-${diaAtualMonth}-${diaAtualDay}`;

      await this.getLocais();
      await this.getVeiculosLab();
      await this.getCarriersFromDynamoDB();
      await this.getUserLogado();
      await this.update();
      this.centerDialog();
      this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
        await this.update();
      });
    } catch (error) {
      console.error('Erro durante a execução do ngOnInit:', error);
    }
    // this.controleExcesso();
  }

  async update() {
    // await this.getItemsFromChegadasLCB();
    await this.getItemsContainer();
    await this.getItemsFromArgentina();
    await this.getItemsFromDynamoDB();
    await this.getItemsFromJanelasReservadas();
    await this.getItemsFromVW();
    await this.getProgramacaoInterplantasFromDynamoDB();
    this.totalReservasRECCONT = await this.removeDuplicados(this.totalReservasRECCONT, this.itemsContainers);
    await this.somarFluxosFinalizado();
    // await this.verificaCorJanela();
    await this.atualizaStatus(this.itemsContainers);
    await this.atualizaStatus(this.totalReservasEXP);
    await this.atualizaStatus(this.totalReservasRECSIDER);
    await this.atualizaStatus(this.totalMR);
    await this.atualizaStatus(this.totalCont);
    await this.atualizaStatus(this.itemsInterplantas);
    await this.atualizaStatus(this.totalReservasEMB);
    await this.atualizaStatus(this.totalReservasEMBMR);
    await this.somarVolumes();
    await this.ordenarJanelas('RECCONT');
    await this.ordenarJanelas('RECSIDER');
    await this.ordenarJanelas('EMB');
    await this.ordenarJanelas('EMBMR');
    await this.ordenarJanelas('INT');
    await this.controleExcesso();
    await this.filtrarItensExcesso();
    this.isLoading = false;
  }

  async atualizaData() {
    this.filtroacionado = true;
    this.isLoading = true;
    this.dataExibir = this.dataExibirPre;
    let novaDataExibir = new Date(this.dataExibir);
    // Adicionar 3 horas à nova data
    novaDataExibir.setHours(novaDataExibir.getHours() + 3);
    // Atualizar this.dataExibir para a nova data
    this.dataExibir = novaDataExibir;
    await this.update();
    this.isLoading = false;
  }

  createPlacaData(): { [key: string]: any[] } {
    return {
      RECCONT: [],
      EMB: [],
      EMBMR: [],
      EXP: [],
      INT: [],
      RECSIDER: [],
    };
  }

  isDateValid(dateString: string) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  zeroSeconds(date: Date): Date {
    const newDate = new Date(date);
    newDate.setSeconds(0, 0);
    return newDate;
  }

  async atualizaStatus(items: any[]) {
    let dataChegadaString = '';
    let dataEntradaString = '';
    let dataSaidaString = '';
    let dataString = '';
    let dataHoraString = '';

    await items.forEach(item => {
      let chegou = false;
      let entrou = false;
      let saiu = false;
      let finalizacaoManualLCB = false;
      let propertyName = "";
      try {
        if (item.dataAlterada) {
          dataString = `${item.dataAlterada}T${item.horaAlterada}:00.000`;
        }
        else if (item.dataJanelaDestino1Alterada) {
          dataString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000`;
        }
        else if (item.dataJanelaDestino2Alterada) {
          dataString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000`;
        }
        else if (item.dataJanelaDestino2Alterada) {
          dataString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000`;
        }
        else if (item.dataJanelaTimeTable && item.horaJanelaTimeTable) {
          dataString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000`;
        }
        else if (item.idContainer && item.Janela) {
          dataString = item.Janela;
        }
        else if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
          dataString = item['JanelaDestino 1'];
          propertyName = "FinalizacaoManualDestino1";
          finalizacaoManualLCB = item[propertyName];
          // item.FinalizacaoManualDestino1
        } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
          dataString = item['JanelaDestino 2'];
          propertyName = "FinalizacaoManualDestino2";
          finalizacaoManualLCB = item[propertyName];
        } else if (item['Janela']) {
          dataString = item['Janela'].toString();
        } else if (item['JanelaDestino 1']) {
          dataString = item['JanelaDestino 1'].toString();
        }
      } catch {
        console.log("com erro!")
        console.log(item)
      }
      if (item['chegada'] && item['chegada'] != "0001-01-01T00:00:00") {
        dataChegadaString = item['chegada'];
      } else if (item['ChegadaLCB'] && item['ChegadaLCB'] != "0001-01-01T00:00:00") {
        dataChegadaString = item['ChegadaLCB'];
      } else {
        dataChegadaString = "0001-01-01T00:00:00";
      }
      // dataChegadaString = item['chegada'] ? item['chegada'] : "0001-01-01T00:00:00";
      try {
        if (dataString.includes("Z")) {
          dataString = dataString.replace("Z", "");
        }
      } catch {
        console.log("com erro!")
        console.log(dataString)
        console.log(item)
      }
      if (item['entrada'] && item['entrada'] != "0001-01-01T00:00:00") {
        dataEntradaString = item['entrada'];
      } else if (item['EntradaLCB'] && item['EntradaLCB'] != "0001-01-01T00:00:00") {
        dataEntradaString = item['EntradaLCB'];
      } else {
        dataEntradaString = "0001-01-01T00:00:00";
      }
      if (item['saida'] && item['saida'] != "0001-01-01T00:00:00") {
        dataSaidaString = item['saida'];
      } else if (item['SaidaLCB'] && item['SaidaLCB'] != "0001-01-01T00:00:00") {
        dataSaidaString = item['SaidaLCB'];
      } else {
        dataSaidaString = "0001-01-01T00:00:00";
      }

      if (dataChegadaString.includes("Z")) {
        dataChegadaString = dataChegadaString.replace("Z", "");
      }
      if (dataEntradaString.includes("Z")) {
        dataEntradaString = dataEntradaString.replace("Z", "");
      }
      if (dataSaidaString.includes("Z")) {
        dataSaidaString = dataSaidaString.replace("Z", "");
      }

      // dataEntradaString = this.isDateValid(item.EntradaLCB); // Deve retornar true
      let dataJanela = new Date(dataString);
      const dataChegada = new Date(dataChegadaString);
      const dataEntrada = new Date(dataEntradaString);
      const dataSaida = new Date(dataSaidaString);
      const dataAtual = new Date();
      const dataZero = new Date("0001-01-01T00:00:00");
      const dataUndefined = new Date("0001-01-01T00:00:00");

      //comparação para KPI de atendimento, considerar OK se chegar 2 horas antes da janela até o horário de janela
      let dataJanelaTolerancia = new Date(dataString);
      dataJanelaTolerancia.setHours(dataJanelaTolerancia.getHours() - 3);
      dataChegada.setSeconds(0, 0);
      dataJanela.setSeconds(0, 0);
      dataJanelaTolerancia.setSeconds(0, 0);
      if ((dataChegada.getTime() != dataZero.getTime()) && (dataChegada >= dataJanelaTolerancia) && (dataChegada <= dataJanela)) {
        item['statusChegada'] = 'OK';
      } else if (((dataChegada.getTime() != dataZero.getTime()) && (dataChegada < dataJanelaTolerancia)) || ((dataChegada.getTime() != dataZero.getTime() && dataChegada > dataJanela))) {
        item['statusChegada'] = 'NOK';
      } else {
        item['statusChegada'] = '';
      }

      if (item.dataJanelaDestino1Alterada) {
        dataHoraString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000`;
      }
      else if (item.dataJanelaDestino2Alterada) {
        dataHoraString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000`;
      }
      else {
        dataHoraString = dataString;
      }

      dataJanela = new Date(dataHoraString);

      const dataJanelaNoSeconds = this.zeroSeconds(dataJanela);
      const dataChegadaNoSeconds = this.zeroSeconds(dataChegada);
      const dataEntradaNoSeconds = this.zeroSeconds(dataEntrada);
      const dataSaidaNoSeconds = this.zeroSeconds(dataSaida);
      const dataAtualNoSeconds = this.zeroSeconds(dataAtual);

      if ((dataChegadaNoSeconds.getTime() != dataZero.getTime()) && (dataChegadaNoSeconds.getTime() != dataUndefined.getTime())) {
        chegou = true;
      }
      if ((dataEntradaNoSeconds.getTime() != dataZero.getTime()) && (dataEntradaNoSeconds.getTime() != dataUndefined.getTime())) {
        entrou = true;
      }
      if ((dataSaidaNoSeconds.getTime() != dataZero.getTime()) && (dataSaidaNoSeconds.getTime() != dataUndefined.getTime())) {
        saiu = true;
      }

      // if (dataJanelaNoSeconds >= dataAtualNoSeconds && !chegou) {
      //   item.statusEntrega = 'emTempo';
      // }
      // if (dataJanelaNoSeconds >= dataAtualNoSeconds && chegou) {
      //   if (saiu) {
      //     item.statusEntrega = 'finalizadoEmTempo';
      //   } else if (entrou) {
      //     item.statusEntrega = 'chegouEntrouEmTempo';
      //   } else if (!entrou) {
      //     item.statusEntrega = 'chegouNaoEntrouEmTempo';
      //   }
      // }
      // if (dataJanelaNoSeconds < dataAtualNoSeconds && !chegou) {
      //   item.statusEntrega = 'atrasado';
      // }
      // if (dataJanelaNoSeconds < dataAtualNoSeconds && chegou) {
      //   if (dataJanelaNoSeconds < dataChegadaNoSeconds) {
      //     if (saiu) {
      //       item.statusEntrega = 'finalizadoAtrasado';
      //     } else if (entrou) {
      //       item.statusEntrega = 'chegouEntrouAtrasado';
      //     } else if (!entrou) {
      //       item.statusEntrega = 'chegouNaoEntrouAtrasado';
      //     }
      //   } else {
      //     if (saiu) {
      //       item.statusEntrega = 'finalizadoEmTempo';
      //     } else if (entrou) {
      //       item.statusEntrega = 'chegouEntrouEmTempo';
      //     } else if (!entrou) {
      //       item.statusEntrega = 'chegouNaoEntrouEmTempo';
      //     }
      //   }
      // }
      if (!chegou) {
        if (dataJanelaNoSeconds >= dataAtualNoSeconds) {
          item.statusEntrega = 'emTempo';
        }
        else if (dataJanelaNoSeconds < dataAtualNoSeconds) {
          item.statusEntrega = 'atrasado';
        }
      } else if (chegou) {
        if (dataJanelaNoSeconds >= dataChegadaNoSeconds) {
          if (saiu) {
            item.statusEntrega = 'finalizadoEmTempo';
          } else if (entrou) {
            item.statusEntrega = 'chegouEntrouEmTempo';
          } else if (!entrou) {
            item.statusEntrega = 'chegouNaoEntrouEmTempo';
          }
        }
        else if (dataJanelaNoSeconds < dataChegadaNoSeconds) {
          // if (dataJanelaNoSeconds < dataChegadaNoSeconds) {
          if (saiu) {
            item.statusEntrega = 'finalizadoAtrasado';
          } else if (entrou) {
            item.statusEntrega = 'chegouEntrouAtrasado';
          } else if (!entrou) {
            item.statusEntrega = 'chegouNaoEntrouAtrasado';
          }
          // } else {
          //   if (saiu) {
          //     item.statusEntrega = 'finalizadoEmTempo';
          //   } else if (entrou) {
          //     item.statusEntrega = 'chegouEntrouEmTempo';
          //   } else if (!entrou) {
          //     item.statusEntrega = 'chegouNaoEntrouEmTempo';
          //   }
          // }
        }
      }

      if (item.FinalizadaManual && finalizacaoManualLCB) {
        // console.log("esta com finalizada manual")
        item.statusEntrega = 'finalizadaManual';
      }
    })
  }


  async somarFluxosFinalizado() {
    let dataHoraString = '';
    this.totalMR = []
    this.totalMR = this.totalMR.concat(this.itemsArg);
    this.totalMR = this.totalMR.concat(this.totalItensJetta);
    this.totalMR = this.totalMR.concat(this.itemsVW);
    // this.totalMR = this.totalMR.concat(this.totalReservasRECCONT);
    this.totalMR.forEach(item => {
      try {
        item.Transportadora = item.description.includes('JSL') ? 'JSL' : item.description.includes('TCM') ? 'TCM' : item.description.includes('SESE') ? 'SESE' : item.description.includes('LOTS') ? 'LOTS' : item.description.includes('ARG') ? 'JSL-ARG' : 'Outros'
        item.Fornecedores = (item['Fornecedor 1'] ? item['Fornecedor 1'] + ', ' : '') + (item['Fornecedor 2'] ? item['Fornecedor 2'] + ', ' : '') + (item['Fornecedor 3'] ? item['Fornecedor 3'] + ', ' : '') + (item['Fornecedor 4'] ? item['Fornecedor 4'] : '')
      } catch {
      }
    })

    // await this.encontrarCorrespondencias(this.totalMR, this.itemsChegadaLCB);
    for (let i = 0; i < 25; i++) {
      this.timeTableGeral[i]['RECSIDER'] = []
    }
    this.totalMR = this.totalMR.concat(this.totalReservasRECSIDER);
    this.totalMR.forEach(async (item, index) => {
      if (item.dataJanelaDestino1Alterada) {
        dataHoraString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
      }
      else if (item.dataJanelaDestino2Alterada) {
        dataHoraString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
      }
      else if (item.dataAlterada) {
        dataHoraString = `${item.dataAlterada}T${item.horaAlterada}:00.000Z`;
      }
      else if (item.dataJanela && item.horaJanela) {
        dataHoraString = `${item.dataJanela}T${item.horaJanela}:00.000`;
      }
      else if (item.dataJanela && item.horario) {
        dataHoraString = `${item.dataJanela}T${item.horario}:00.000`;
      }
      else {
        dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
      }
      if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
        // console.log(item['JanelaDestino 1'])
        await this.ajusteTimeTable(item, 'RECSIDER', dataHoraString, item['Destino 1']);
      } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
        await this.ajusteTimeTable(item, 'RECSIDER', dataHoraString, item['Destino 2']);
      } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
        await this.ajusteTimeTable(item, 'RECSIDER', dataHoraString, item['Destino 3']);
      }
    })

    for (let i = 0; i < 25; i++) {
      this.timeTableGeral[i]['EXP'] = []
    }
    this.totalReservasEXP.forEach(async (item, index) => {
      // console.log(item)
      if (item.dataJanelaDestino1Alterada) {
        dataHoraString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
      }
      else if (item.dataJanelaDestino2Alterada) {
        dataHoraString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
      }
      else if (item.dataAlterada) {
        dataHoraString = `${item.dataAlterada}T${item.horaAlterada}:00.000Z`;
      }
      else {
        dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
      }
      if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
        await this.ajusteTimeTable(item, 'EXP', dataHoraString, item['Destino 1']);
      } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
        await this.ajusteTimeTable(item, 'EXP', dataHoraString, item['Destino 2']);
      } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
        await this.ajusteTimeTable(item, 'EXP', dataHoraString, item['Destino 3']);
      }
    })

    this.itemsContainersReuse.forEach(async (item, index) => {
      if (item.dataJanelaDestino1Alterada) {
        dataHoraString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
      }
      else if (item.dataJanelaDestino2Alterada) {
        dataHoraString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
      }
      else if (item.dataAlterada) {
        dataHoraString = `${item.dataAlterada}T${item.horaAlterada}:00.000Z`;
      }
      else {
        dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
      }
      if (item.destino && item.destino.toUpperCase().includes('LCB')) {
        // let date1str = item["Janela"].replace("Z", "");
        let date1str = dataHoraString.replace("Z", "");
        let janela = new Date(date1str)
        janela.setHours(janela.getHours() + 1);
        await this.ajusteTimeTable(item, 'EXP', janela.toString(), item.destino);
      }
    })

    for (let i = 0; i < 25; i++) {
      this.timeTableGeral[i]['RECCONT'] = []
    }

    this.totalCont = this.itemsContainers;
    this.totalCont = this.totalCont.concat(this.totalReservasRECCONT);

    this.totalCont.forEach(async (item, index) => {
      if (item.dataJanelaDestino1Alterada) {
        dataHoraString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
      }
      else if (item.dataJanelaDestino2Alterada) {
        dataHoraString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
      }
      else if (item.dataAlterada) {
        dataHoraString = `${item.dataAlterada}T${item.horaAlterada}:00.000Z`;
      }
      else {
        dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
      }
      await this.ajusteTimeTable(item, 'RECCONT', dataHoraString, item.destino);
    })

    for (let i = 0; i < 25; i++) {
      this.timeTableGeral[i]['EMB'] = []
    }
    this.totalReservasEMB.forEach(async (item, index) => {
      if (item.dataAlterada) {
        dataHoraString = `${item.dataAlterada}T${item.horaAlterada}:00.000Z`;
      }
      else {
      dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
      }
      if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
        await this.ajusteTimeTable(item, 'EMB', dataHoraString, item['Destino 1']);
      } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
        await this.ajusteTimeTable(item, 'EMB', dataHoraString, item['Destino 2']);
      } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
        await this.ajusteTimeTable(item, 'EMB', dataHoraString, item['Destino 3']);
      }
    })

    for (let i = 0; i < 25; i++) {
      this.timeTableGeral[i]['EMBMR'] = []
    }
    this.totalReservasEMBMR.forEach(async (item, index) => {
      if (item.dataAlterada) {
        dataHoraString = `${item.dataAlterada}T${item.horaAlterada}:00.000Z`;
      }
      else {
      dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
      }
      if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
        await this.ajusteTimeTable(item, 'EMBMR', dataHoraString, item['Destino 1']);
      } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
        await this.ajusteTimeTable(item, 'EMBMR', dataHoraString, item['Destino 2']);
      } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
        await this.ajusteTimeTable(item, 'EMBMR', dataHoraString, item['Destino 3']);
      }
    })

    for (let i = 0; i < 25; i++) {
      this.timeTableGeral[i]['INT'] = []
    }
    // console.log(this.itemsInterplantas)
    this.itemsInterplantas.forEach(async (item, index) => {
      // console.log(item)
      // console.log("entrou no interplantas")
      // await this.ajusteTimeTable((item), 'INT', item['Janela'])
      if (item.dataJanelaDestino1Alterada !== undefined) {
        dataHoraString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
      }
      else if (item.dataJanelaDestino2Alterada !== undefined) {
        dataHoraString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
      }
      else if (item.dataAlterada !== undefined) {
        dataHoraString = `${item.dataAlterada}T${item.horaAlterada}:00.000Z`;
      }
      else {
        dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
      }
      // console.log(item['Janela'])
      if (item.Local == 'R27' || item.Local == 'R26') {
        const ajusteHora = new Date(dataHoraString);
        if (item.dataAlterada === undefined) {
        ajusteHora.setMinutes(ajusteHora.getMinutes() - 75);
          item.dataJanelaTimeTable = ajusteHora.toISOString().slice(0, 10); // "2024-04-23"
          item.horaJanelaTimeTable = ajusteHora.toISOString().slice(11, 16); // "00:00"  
        }
        await this.ajusteTimeTable(item, 'INT', ajusteHora.toISOString())
      }
      if (item.Local == 'E37') {
        const ajusteHora = new Date(dataHoraString);
        if (item.dataAlterada === undefined) {
          ajusteHora.setMinutes(ajusteHora.getMinutes() + 90);
          item.dataJanelaTimeTable = ajusteHora.toISOString().slice(0, 10); // "2024-04-23"
          item.horaJanelaTimeTable = ajusteHora.toISOString().slice(11, 16); // "00:00"  
        }
        await this.ajusteTimeTable((item), 'EMB', ajusteHora.toISOString())
      }
      if (item.Local != 'E37' && item.Local != 'R27' && item.Local != 'R26') {
        const ajusteHora = new Date(dataHoraString);
        if (item.dataAlterada === undefined) {
          ajusteHora.setMinutes(ajusteHora.getMinutes() - 90);
          item.dataJanelaTimeTable = ajusteHora.toISOString().slice(0, 10); // "2024-04-23"
          item.horaJanelaTimeTable = ajusteHora.toISOString().slice(11, 16); // "00:00"  
        }        
        await this.ajusteTimeTable((item), 'INT', ajusteHora.toString())
      }
    })
  }

  onFieldTouched() {
    this.campoTocado = true;
  }

  ordenarJanelas(area: string) {
    for (let i = 0; i < 24; i++) {
      this.timeTableGeral[i][area] = this.timeTableGeral[i][area].sort((a, b) => {
        let dataA = a.created;
        let dataB = b.created;
        if (a.lastUpdate) {
          dataA = a.lastUpdate;
        }
        if (b.lastUpdate) {
          dataB = b.lastUpdate;
        }
        const normalizeDate = (date: string) => {
          if (!isNaN(Number(date))) {
            return new Date(Number(date));
          }
          return new Date(date);
        };
        const dateA = normalizeDate(dataA);
        const dateB = normalizeDate(dataB);
        return dateA.getTime() - dateB.getTime();
      });
    }
  }



  somarVolumes() {
    const areas = ['RECCONT', 'RECSIDER', 'EXP', 'INT', 'EMB', 'EMBMR'];
    // Zerar os valores de this.valorItemVolume
    for (let i = 0; i < this.valorItemVolume.length; i++) {
      for (let j = 0; j < areas.length; j++) {
        this.valorItemVolume[i][j] = 0;
      }
    }
    // Objeto para armazenar os volumes totais para cada área
    const volumesTotaisPorArea: { [key: string]: number[] } = {};
    // Inicializar o array para armazenar os valores de volume por item e por área
    // Iterar sobre cada área
    areas.forEach((area, i) => {
      // console.log(area);      
      // Inicializar o array de volumes totais para a área atual
      volumesTotaisPorArea[area] = [];
      // Iterar sobre cada item da área atual
      this.timeTableGeral.forEach((item, index) => {
        // console.log(item);          
        item[area].forEach(subItem => {
          // console.log(subItem);
          const volumesComoNumero = parseFloat(subItem.Volumes);
          if (!isNaN(volumesComoNumero)) {
            this.valorItemVolume[index][i] += volumesComoNumero;
            // Adicionar o volume do subItem ao array de volumes totais para a área atual
            volumesTotaisPorArea[area].push(volumesComoNumero);
          }
        });
      });
    });
    // console.log(this.valorItemVolume);
  }

  isISODateValid(dateString: string) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  controleExcesso() {
    this.timeTableExcesso = [];
    this.classHora = [];  // Adicionando uma assinatura de índice
    for (let i = 0; i < 25; i++) {
      const startIndex = 4;
      const endIndex = this.timeTableGeral[i]['RECCONT'].length;
      // console.log(this.timeTableGeral[i]['RECCONT'])

      // this.timeTableGeral[i]['RECCONT'] = this.timeTableGeral[i]['RECCONT'].filter(element => element !== undefined && element !== null);
      if (this.timeTableGeral[i]['RECCONT'].length > 4) {
        // console.log(startIndex)
        // console.log(endIndex)
        // console.log(this.timeTableGeral[i]['RECCONT'])
        this.classHora[i] = "semClasse";
        // const uniqueItemsMap: { [key: string]: any } = {};  // Objeto para armazenar itens únicos
        for (let j = startIndex; j < endIndex; j++) {
          //   console.log("entrou no for")
          // console.log(this.timeTableGeral[i]['RECCONT'][j])          
          if (this.timeTableGeral[i]['RECCONT'][j]) {
            const item = this.timeTableGeral[i]['RECCONT'][j];
            // console.log(item.Plate)
            item.Area = 'RECCONT';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
            // this.timeTableExcesso.forEach(itemExcesso => {
            //   for (let k = 0; k < 25; k++) {
            //     const id = itemExcesso.ID
            //     // console.log(id)
            //     const index = this.timeTableGeral[k]['RECCONT'].findIndex(element => element.ID === id);
            //     if (index !== -1) {        
            //       console.log(this.timeTableGeral[k]['RECCONT'][index])
            //       this.timeTableGeral[k]['RECCONT'].splice(index, 1);
            //     }
            //   }
            // })
          }
        }
        // console.log(this.timeTableExcesso)
      }
      if (this.timeTableGeral[i]['RECSIDER'].length > 3) {
        const startIndex = 3;
        const endIndex = this.timeTableGeral[i]['RECSIDER'].length;
        this.classHora[i] = "semClasse";
        for (let m = startIndex; m < endIndex; m++) {
          if (this.timeTableGeral[i]['RECSIDER'][m]) {
            const item = this.timeTableGeral[i]['RECSIDER'][m];
            item.Area = 'RECSIDER';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
            // this.timeTableExcesso.forEach(itemExcesso => {
            //   for (let l = 0; l < 25; l++) {
            //     const id = itemExcesso.ID
            //     const index = this.timeTableGeral[l]['RECSIDER'].findIndex(element => element.ID === id);
            //     if (index !== -1) {
            //       this.timeTableGeral[l]['RECSIDER'].splice(index, 1);
            //     }
            //   }
            // })
          }
        }
      }
      if (this.timeTableGeral[i]['EMB'].length > 1) {
        const startIndex = 1;
        const endIndex = this.timeTableGeral[i]['EMB'].length;
        this.classHora[i] = "semClasse";
        for (let m = startIndex; m < endIndex; m++) {
          if (this.timeTableGeral[i]['EMB'][m]) {
            const item = this.timeTableGeral[i]['EMB'][m];
            item.Area = 'EMB';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
            // this.timeTableExcesso.forEach(itemExcesso => {
            //   for (let l = 0; l < 25; l++) {
            //     const id = itemExcesso.ID
            //     const index = this.timeTableGeral[l]['RECSIDER'].findIndex(element => element.ID === id);
            //     if (index !== -1) {
            //       this.timeTableGeral[l]['RECSIDER'].splice(index, 1);
            //     }
            //   }
            // })
          }
        }
      }
      if (this.timeTableGeral[i]['EMBMR'].length > 1) {
        const startIndex = 1;
        const endIndex = this.timeTableGeral[i]['EMBMR'].length;
        this.classHora[i] = "semClasse";
        for (let m = startIndex; m < endIndex; m++) {
          if (this.timeTableGeral[i]['EMBMR'][m]) {
            const item = this.timeTableGeral[i]['EMBMR'][m];
            item.Area = 'EMBMR';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
            // this.timeTableExcesso.forEach(itemExcesso => {
            //   for (let l = 0; l < 25; l++) {
            //     const id = itemExcesso.ID
            //     const index = this.timeTableGeral[l]['RECSIDER'].findIndex(element => element.ID === id);
            //     if (index !== -1) {
            //       this.timeTableGeral[l]['RECSIDER'].splice(index, 1);
            //     }
            //   }
            // })
          }
        }
      }
      if (this.timeTableGeral[i]['EXP'].length > 3) {
        const startIndex = 3;
        const endIndex = this.timeTableGeral[i]['EXP'].length;
        this.classHora[i] = "semClasse";
        for (let m = startIndex; m < endIndex; m++) {
          if (this.timeTableGeral[i]['EXP'][m]) {
            const item = this.timeTableGeral[i]['EXP'][m];
            item.Area = 'EXP';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
            // this.timeTableExcesso.forEach(itemExcesso => {
            //   for (let l = 0; l < 25; l++) {
            //     const id = itemExcesso.ID
            //     const index = this.timeTableGeral[l]['RECSIDER'].findIndex(element => element.ID === id);
            //     if (index !== -1) {
            //       this.timeTableGeral[l]['RECSIDER'].splice(index, 1);
            //     }
            //   }
            // })
          }
        }
      }
    }

    try {
      this.timeTableExcesso.forEach(async item => {
        if (item.dataJanelaDestino1Alterada) {
          item.Janela = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
        }
        else if (item.dataJanelaDestino2Alterada) {
          item.Janela = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
        }
        else if (item.dataAlterada) {
          item.Janela = `${item.dataAlterada}T${item.horaAlterada}:00.000Z`;
        }
        else {
          item.Janela = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
        }
        // item.Janela = item.Janela && this.isValidDate(item.Janela) ? item.Janela : item["Destino 1"].toUpperCase().includes('LCB') ? item["JanelaDestino 1"] : item["JanelaDestino 2"]
        // let dataString = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["JanelaDestino 1"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["JanelaDestino 2"] :
        //   (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["JanelaDestino 3"] : (item["destino"] && item["destino"].toUpperCase().includes('LCB')) ? item["Janela"] : new Date().toDateString();
        // console.log(dataString)
        // try {
        //   item.dataJanelaDestino1 = dataString.slice(0, 10); // "2024-04-23"
        //   item.horaJanelaDestino1 = dataString.slice(11, 16); // "00:00"  
        // } catch {
        //   console.log("com erro")
        // }
        try {
          if (item.description?.includes("JSL")) {
            item.Transportadora = "JSL"
          }
          else if (item.description?.includes("TCM")) {
            item.Transportadora = "TCM"
          }
          else if (item.description?.includes("ARG")) {
            item.Transportadora = "JSL"
          }
          else if (item.Transportadora) {
            item.Transportadora = item.Transportadora
          }
          else {
            item.Transportadora = ""
          }
          item.Janela = this.formatarData(item.Janela);
        } catch (error) {
          item.Janela = item.Janela.toString();
          item.Janela = this.formatarData(item.Janela);
        }
      })
    } catch {
      console.log("Erro na construção da time table excesso")
    }
  }

  async filtrarItensExcesso() {
    const filtrosSelecionados: string[] = [];  
    if (this.RECCONT) filtrosSelecionados.push("RECCONT");
    if (this.EXP) filtrosSelecionados.push("EXP");
    if (this.INT) filtrosSelecionados.push("INT");
    if (this.EMB) filtrosSelecionados.push("EMB");
    if (this.EMBMR) filtrosSelecionados.push("EMBMR");
    if (this.RECSIDER) filtrosSelecionados.push("RECSIDER");  
    // Filtra os itens onde a propriedade "Area" está na lista de selecionados
    this.timeTableExcessoFiltrados = this.timeTableExcesso.filter(item =>
      filtrosSelecionados.includes(item.Area)
    );
  }

  async ajusteTimeTable(item: any, area: string, janela: string, destino?: string): Promise<void> {
    return new Promise<void>(async (resolve) => {
      let date1str = '';
      if (area == 'INT') {
        // date1str = item["Janela"].replace("Z", "");
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'RECCONT') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
        // let dataIgual = await this.compareDatesSemHoras(date1str, this.dataExibir.toDateString());
      //   console.log("dataIgual:", dataIgual);
      // console.log("date1str:", date1str);

      } else if (area == 'RECSIDER') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'EMB') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      }  else if (area == 'EMBMR') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'EXP') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      }
      // const horaDoDia = new Date(date1str).getHours();
      const date1 = new Date(date1str);
      const horaDoDia = date1.getHours();
      const minutos = date1.getMinutes();
      // console.log("Horas:", horaDoDia);
      // console.log("Minutos:", minutos);
      // Use um switch ou if para categorizar com base na hora do dia
      let dataIgual = await this.compareDatesSemHoras(date1str, this.dataExibir.toDateString());
      if(dataIgual == 0){
      let periodoDoDia;
      switch (true) {
        case (horaDoDia == 0 && minutos > 5) || (horaDoDia == 1 && minutos <= 5):
          periodoDoDia = "01:00 - 02:00";
          this.timeTableGeral[1][area].push(item)
          break;
        case (horaDoDia == 1 && minutos > 5) || (horaDoDia == 2 && minutos <= 5):
          periodoDoDia = "02:00 - 03:00";
          this.timeTableGeral[2][area].push(item)

          break;
        case (horaDoDia == 2 && minutos > 5) || (horaDoDia == 3 && minutos <= 5):
          // case horaDoDia == 2 && minutos <= 5:
          periodoDoDia = "03:00 - 04:00";
          this.timeTableGeral[3][area].push(item)

          break;
        case (horaDoDia == 3 && minutos > 5) || (horaDoDia == 4 && minutos <= 5):
          // case horaDoDia >= 3 && horaDoDia < 4:
          periodoDoDia = "04:00 - 05:00";
          this.timeTableGeral[4][area].push(item)

          break;
        case (horaDoDia == 4 && minutos > 5) || (horaDoDia == 5 && minutos <= 5):
          // case horaDoDia >= 4 && horaDoDia <= 5:
          periodoDoDia = "05:00 - 06:00";
          this.timeTableGeral[5][area].push(item)

          break;
        case (horaDoDia == 5 && minutos > 5) || (horaDoDia == 6 && minutos <= 5):
          // case horaDoDia >= 5 && horaDoDia < 6:
          periodoDoDia = "06:00 - 07:00";
          this.timeTableGeral[6][area].push(item)

          break;
        case (horaDoDia == 6 && minutos > 5) || (horaDoDia == 7 && minutos <= 5):
          // case horaDoDia >= 6 && horaDoDia < 7:
          periodoDoDia = "07:00 - 08:00";
          this.timeTableGeral[7][area].push(item)

          break;
        case (horaDoDia == 7 && minutos > 5) || (horaDoDia == 8 && minutos <= 5):
          // case horaDoDia >= 7 && horaDoDia < 8:
          periodoDoDia = "08:00 - 09:00";
          this.timeTableGeral[8][area].push(item)

          break;
        case (horaDoDia == 8 && minutos > 5) || (horaDoDia == 9 && minutos <= 5):
          // case horaDoDia >= 8 && horaDoDia < 9:
          periodoDoDia = "09:00 - 10:00";
          this.timeTableGeral[9][area].push(item)

          break;
        case (horaDoDia == 9 && minutos > 5) || (horaDoDia == 10 && minutos <= 5):
          // case horaDoDia >= 9 && horaDoDia < 10:
          periodoDoDia = "10:00 - 11:00";
          this.timeTableGeral[10][area].push(item)

          break;
        case (horaDoDia == 10 && minutos > 5) || (horaDoDia == 11 && minutos <= 5):
          // case horaDoDia >= 10 && horaDoDia < 11:
          periodoDoDia = "11:00 - 12:00";
          this.timeTableGeral[11][area].push(item)

          break;
        case (horaDoDia == 11 && minutos > 5) || (horaDoDia == 12 && minutos <= 5):
          // case horaDoDia >= 11 && horaDoDia < 12:
          periodoDoDia = "12:00 - 13:00";
          this.timeTableGeral[12][area].push(item)

          break;
        case (horaDoDia == 12 && minutos > 5) || (horaDoDia == 13 && minutos <= 5):
          // case horaDoDia >= 12 && horaDoDia < 13:
          periodoDoDia = "13:00 - 14:00";
          this.timeTableGeral[13][area].push(item)

          break;
        case (horaDoDia == 13 && minutos > 5) || (horaDoDia == 14 && minutos <= 5):
          // case horaDoDia >= 13 && horaDoDia < 14:
          periodoDoDia = "14:00 - 15:00";
          this.timeTableGeral[14][area].push(item)

          break;
        case (horaDoDia == 14 && minutos > 5) || (horaDoDia == 15 && minutos <= 5):
          // case horaDoDia >= 14 && horaDoDia < 15:
          periodoDoDia = "15:00 - 16:00";
          this.timeTableGeral[15][area].push(item)

          break;
        case (horaDoDia == 15 && minutos > 5) || (horaDoDia == 16 && minutos <= 5):
          // case horaDoDia >= 15 && horaDoDia < 16:
          periodoDoDia = "16:00 - 17:00";
          this.timeTableGeral[16][area].push(item)

          break;
        case (horaDoDia == 16 && minutos > 5) || (horaDoDia == 17 && minutos <= 5):
          // case horaDoDia >= 16 && horaDoDia < 17:
          periodoDoDia = "17:00 - 18:00";
          this.timeTableGeral[17][area].push(item)

          break;
        case (horaDoDia == 17 && minutos > 5) || (horaDoDia == 18 && minutos <= 5):
          // case horaDoDia >= 17 && horaDoDia < 18:
          periodoDoDia = "18:00 - 19:00";
          this.timeTableGeral[18][area].push(item)

          break;
        case (horaDoDia == 18 && minutos > 5) || (horaDoDia == 19 && minutos <= 5):
          // case horaDoDia >= 18 && horaDoDia < 19:
          periodoDoDia = "19:00 - 20:00";
          this.timeTableGeral[19][area].push(item)

          break;
        case (horaDoDia == 19 && minutos > 5) || (horaDoDia == 20 && minutos <= 5):
          // case horaDoDia >= 19 && horaDoDia < 20:
          periodoDoDia = "20:00 - 21:00";
          this.timeTableGeral[20][area].push(item)

          break;
        case (horaDoDia == 20 && minutos > 5) || (horaDoDia == 21 && minutos <= 5):
          // case horaDoDia >= 20 && horaDoDia < 21:
          periodoDoDia = "21:00 - 22:00";
          this.timeTableGeral[21][area].push(item)

          break;
        case (horaDoDia == 21 && minutos > 5) || (horaDoDia == 22 && minutos <= 5):
          // case horaDoDia >= 21 && horaDoDia < 22:
          periodoDoDia = "22:00 - 23:00";
          this.timeTableGeral[22][area].push(item)

          break;
        case (horaDoDia == 22 && minutos > 5) || (horaDoDia == 23 && minutos <= 5):
          // case horaDoDia >= 22 && horaDoDia < 23:
          periodoDoDia = "23:00 - 24:00";
          this.timeTableGeral[23][area].push(item)

          break;
        case (horaDoDia == 0 && minutos <= 5):
          // case horaDoDia >= 23 && horaDoDia < 24:
          periodoDoDia = "00:00 - 01:00";
          this.timeTableGeral[0][area].push(item)
          break;
        default:
          periodoDoDia = "Outro período do dia";
      }
    }
      // this.timeTableGeral.forEach(item => {
      //   console.log(item['EMB'])
      // })
      // console.log(this.timeTableGeral[15]['RECCONT'])
      // console.log(this.timeTableGeral[15]['RECCONT'].length)
      resolve();
    });
    // //console.log(`O objeto está no período do dia: ${periodoDoDia}`);
  }

  async getLocais(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.tableNameLocation, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.locais = items;
              // console.log(this.locais)
              this.locaisName = this.locais.map(item => item.local);
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getVeiculosLab(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.queryVeiculosLab, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculosLab = items
              .map(item => ({ ...item, checked: false }));
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getFornecedoresFromDynamoDB(): Promise<void> {
    //console.log("entrou em getFornecedoresFromDynamoDB")
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.query3, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          // //console.log(items)
          if (Array.isArray(items)) {
            this.fornecedores = items.map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
            this.fornecedores = this.fornecedores.sort((a, b) => a.local.localeCompare(b.local));
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  compareDates(date1str: string, date2str: string): number {
    let dateSTRsemZ = date1str.replace("Z", "");
    let dateSTR2semZ = date2str.replace("Z", "");
    const date1 = new Date(dateSTRsemZ);
    const date2 = new Date(dateSTR2semZ);
    const timestamp1 = date1.getTime();
    const timestamp2 = date2.getTime();
    // //console.log(date1)
    // //console.log(date2)
    if (timestamp1 < timestamp2) {
      return -1; // date1 é anterior a date2
    } else if (timestamp1 > timestamp2) {
      return 1; // date1 é posterior a date2
    } else {
      return 0; // date1 é igual a date2
    }
  }

  compareDates2(date1str: string, date2str: string): number {
    const date1 = new Date(date1str);
    const date2 = new Date(date2str);
    const timestamp1 = date1.getTime();
    const timestamp2 = date2.getTime();
    // //console.log(date1)
    // //console.log(date2)
    if (timestamp1 < timestamp2) {
      return -1; // date1 é anterior a date2
    } else if (timestamp1 > timestamp2) {
      return 1; // date1 é posterior a date2
    } else {
      return 0; // date1 é igual a date2
    }
  }

  isValorValido(value: any): boolean {
    // const data = this.isDateValid(value);
    return value !== '' && value !== null && value !== undefined;
  }

  editDialog(item: any): void {
    this.campoTocado = false;
    console.log(item)
    console.log(item.dataJanelaTimeTable)
    this.atualPlate = item.Plate;
    const companyUsuarioLogado = this.usuarioLogado.company?.toLowerCase();
    const transportadoraItem = item.Transportadora?.toLowerCase();
    // console.log(item.Transportadora)
    // console.log(this.usuarioLogado.company)
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '7' && item.area == 'RECSIDER') || (this.usuarioLogado.role == '3' && transportadoraItem.includes(companyUsuarioLogado))) {
      // console.log("edit 1")
      this.item = { ...item };
      // console.log(item.forn1)
      // console.log(item.jan1)
      // console.log(item.Plate)
      // console.log(item.Volumes)
      if (item.description && item.description?.includes("JSL")) {
        this.item.transportadora = "JSL"
      }
      else if (item.description && item.description?.includes("TCM")) {
        this.item.transportadora = "TCM"
      }
      else if (item.description && item.description?.includes("ARG")) {
        this.item.transportadora = "JSL"
      }
      else if (item.Transportadora) {
        this.item.transportadora = item.Transportadora
      }
      else {
        this.item.transportadora = "Sem registro"
      }
      this.item.Plate = item.Plate;
      this.item.Volumes = item.Volumes;
      this.item.idContainer = item.idContainer;
      this.item.forn1 = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["Destino 1"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["Destino 2"] :
        (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["Destino 3"] : (item["destino"] && item["destino"].toUpperCase().includes('LCB')) ? item["destino"] : item.forn1
      this.item.jan1 = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["JanelaDestino 1"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["JanelaDestino 2"] :
        (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["JanelaDestino 3"] : (item["destino"] && item["destino"].toUpperCase().includes('LCB')) ? item["Janela"] : this.item.jan1
      this.item.destinoIndex = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? "Destino 1" : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? "Destino 2" :
        (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? "Destino 3" : "semIndex"
      this.item.janelaIndex = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? "JanelaDestino 1" : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? "JanelaDestino 2" :
        (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? "JanelaDestino 3" : "semIndex"
      const dataHoraString = this.item.jan1;
      this.item.dataAlterada = item.dataAlterada ? item.dataAlterada : item.dataJanelaDestino1Alterada ? item.dataJanelaDestino1Alterada : item.dataJanelaDestino2Alterada;
      this.item.horaAlterada = item.horaAlterada ? item.horaAlterada : item.horaJanelaDestino1Alterada ? item.horaJanelaDestino1Alterada : item.horaJanelaDestino2Alterada;
      this.item.motAlteracao = item.motAlteracao;
      this.item.tableName = item.tableName;
      this.item.ID = item.ID
      this.dialogOpen = true;
      // console.log(this.item)
    } else {
      const confirmacao = window.confirm("Usuário não autorizado!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.dialogOpen = false;
      }
    }
  }

  async calculoConsumo(container: any): Promise<any> {
    // for (const container of items) {
    let atualLocation = { local: "", latitude: 0, longitude: 0 };
    let distance1 = [0, 0];
    let distance2 = [0, 0];
    let distanceTotal = [0, 0];
    const origemLocation = this.findLocationByName(container.terminalOrigem, this.locais);
    atualLocation = await this.findLocationByName(container.terminalAtual, this.locais);
    const destinoLocation = await this.findLocationByName(container.destino, this.locais);
    if (origemLocation && atualLocation) {
      const origemLocationNumber = this.convertItem(origemLocation);
      var atualLocationNumber = this.convertItem(atualLocation);
      distance1 = await this.calcularRota([origemLocationNumber.longitude, origemLocationNumber.latitude], [atualLocationNumber.longitude, atualLocationNumber.latitude]);
      container.distanceTrecho1 = distance1[0];
    }
    if (destinoLocation && atualLocation) {
      const destinoLocationNumber = this.convertItem(destinoLocation);
      var atualLocationNumber = this.convertItem(atualLocation);
      distance2 = await this.calcularRota([destinoLocationNumber.longitude, destinoLocationNumber.latitude], [atualLocationNumber.longitude, atualLocationNumber.latitude]);
      container.distanceTrecho2 = distance2[0];
    }
    // console.log(container.idContainer)
    // console.log(container.distanceTrecho1)
    // console.log(container.distanceTrecho2)
    container['Transport Type'] = this.veiculosLab.find((veiculo: { placa: any; }) => veiculo.placa == container.Plate)
      ? this.veiculosLab.find((veiculo: { placa: any; }) => veiculo.placa == container.Plate).modelo
      : "R450 LA4x2MNA";
    container.emissao = this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type'])
      ? this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type']).emissoes
      : 0;
    container.consumo = this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type'])
      ? this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type']).consumo
      : 0;
    container.emissaoTrecho1 = (container.distanceTrecho1 * container.emissao) / container.consumo;
    container.emissaoTrecho2 = (container.distanceTrecho2 * container.emissao) / container.consumo;

    container['Total Distance'] = container.distanceTrecho1 + container.distanceTrecho2;
    container['emissaoTotal'] = container.emissaoTrecho1 + container.emissaoTrecho2;
    // console.log(container['Total Distance'])
    // }
    // console.log(items)
    return container;
  }

  findLocationByName(name: string, locations: any[]): Location {
    return locations['find']((location: { local: string; }) => location.local === name);
  }


  convertItem(item: any): any {
    return {
      ID: item.ID,
      latitude: parseFloat(item.latitude),  // Convertendo latitude para número
      local: item.local,
      longitude: parseFloat(item.longitude),  // Convertendo longitude para número
      tableName: item.tableName
    };
  }

  async calcularRota(startLocation: number[], endLocation: number[]): Promise<[number, number]> {
    try {
      // console.log(startLocation)
      // console.log(endLocation)
      const response: any = await (await this.dynamodbService.getRota("https://klyufov1p0.execute-api.sa-east-1.amazonaws.com/v1/POST", startLocation, endLocation)).toPromise();
      if (response.statusCode === 200) {
        const data = response.body;
        if (data) {
          const distance = data.Distance;
          const durationSeconds = data.DurationSeconds;
          return [distance, durationSeconds];
        } else {
          console.error('Data not found in the response:', data);
          return [0, 0];
        }
      } else {
        console.error('Invalid response:', response);
        return [0, 0];
      }
    } catch (error) {
      console.error('Error processing data:', error);
      return [0, 0];
    }
  }

  editDialog2(area: string): void {
    // const companyUsuarioLogado = this.usuarioLogado.company?.toLowerCase();
    // console.log(item.Transportadora)
    // console.log(this.usuarioLogado.company)
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || this.usuarioLogado.role == '5' || 
      (this.usuarioLogado.role == '3' && area == 'RECSIDER') || (this.usuarioLogado.role == '3' && area == 'EMB') || (this.usuarioLogado.role == '3' && area == 'EMBMR')) {
      // console.log("edit 2");
      this.edit2 = true;
      this.item = [];
      this.item.Plate = null;
      this.item.Transportadora = null;
      this.item.Volumes = null;
      this.item.idContainer = null;
      this.item.forn1 = "LCB DEMARCHI";
      this.item.dataJanela = null;
      this.item.horaJanela= null;
      this.item.dataJanelaTimeTable = null;
      this.item.horaJanelaTimeTable = null;
      // this.item.jan1 = "";
      this.item['JanelaDestino 1'] = null;
      this.item.destinoIndex = 'Destino 1';
      this.item.janelaIndex = 'JanelaDestino 1';
      this.item.date = new Date();
      this.item.area = area;
      const currentDate = new Date().getTime();
      this.item.created = currentDate.toString();
      this.item.createdBy = this.usuarioLogado.id;
      const id = new Date().getTime();
      this.item.ID = id.toString();
      this.item.tableName = this.queryTimeTable;
      this.dialogOpen = true;
    } else {
      const confirmacao = window.confirm("Usuário não autorizado!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.dialogOpen = false;
      }
    }
  }

  async reservaEmbalagem(item: any) {
    this.isLoading = true;
    this.dialogOpen = false;
    const currentDate = new Date().getTime();
    let janelaStr = '';
    let destino = '';
    let janela = new Date();
    if (item.dataJanelaDestino1Alterada) {
      janelaStr = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
      janela = new Date(janelaStr);
    }
    else if (item.dataJanelaDestino2Alterada) {
      janelaStr = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
      janela = new Date(janelaStr);
    }
    else if (item.dataAlterada) {
      janelaStr = `${item.dataAlterada}T${item.horaAlterada}:00.000Z`;
      janela = new Date(janelaStr);
    }
    else if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
      destino = item["Destino 1"];
      janelaStr = item["JanelaDestino 1"];
      janela = new Date(janelaStr)
    } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
      destino = item["Destino 2"];
      janelaStr = item["JanelaDestino 2"];
      janela = new Date(janelaStr);
    } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
      destino = item["Destino 3"];
      janelaStr = item["JanelaDestino 3"];
      janela = new Date(janelaStr);
    }
    // console.log(janela)
    janela.setHours(janela.getHours() + 1);
    // console.log(janela)
    janelaStr = janela.toISOString()
    // console.log(janelaStr)
    // this.totalItensJetta.forEach(item => {
    //   if (item.coletaEmbalagem) {
    // Verifica se já existe um item com o mesmo ID
    const exists = this.totalReservasEMBMR.some((existingItem: { ID: any; }) => existingItem.ID === item.ID);
    // Se não existir, adiciona o item
    if (!exists) {
      this.item = item;
      if (this.item.tableName == "janelasTimeTable") {
        this.item.ID = item.ID + "EMBMR";
      }
      // this.item["Destino 1"] = destino;
      // this.item[indexDestino] = janela;
      this.item.dataJanela = janelaStr.slice(0, 10); // "2024-04-23"
      this.item.horaJanela = janelaStr.slice(11, 16); // "00:00"  
      this.item.dataJanelaTimeTable = janelaStr.slice(0, 10); // "2024-04-23"
      this.item.horaJanelaTimeTable = janelaStr.slice(11, 16); // "00:00"  
      this.item.dataAlterada = janelaStr.slice(0, 10); // "2024-04-23"
      this.item.horaAlterada = janelaStr.slice(11, 16); // "00:00"  
      this.item.area = "EMBMR";
      this.item.date = new Date();
      this.item.tableName = this.queryTimeTable;
      this.item.created = currentDate.toString();      
      this.item.createdBy = this.usuarioLogado.id;
      const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      // console.log(jsonArray)
      await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
        // console.log(response)
        await this.update();
        this.edit2 = false;
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
      });
      // this.itemsMRColetaEmbalagem.push(item);
    }
    else {
      return;
    }
    // }
    // });
  }

  async AtualizaReservaEmbalagem(item: any) {
    // console.log(item)
    const exists = this.totalReservasEMB.some((existingItem: { ID: any; }) => existingItem.ID === item.ID);
    const existsMR = this.totalReservasEMBMR.some((existingItem: { ID: any; }) => existingItem.ID === item.ID);
    // Se não existir, adiciona o item
    if (!exists && !existsMR) {
      return
    }else {
      this.isLoading = true;
      this.dialogOpen = false;
      let janelaStr = '';
      let destino = '';
      let janela = new Date();
      if (item.dataJanelaDestino1Alterada) {
        janelaStr = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
        janela = new Date(janelaStr);
      }
      else if (item.dataJanelaDestino2Alterada) {
        janelaStr = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
        janela = new Date(janelaStr);
      }
      else if (item.dataAlterada) {
        janelaStr = `${item.dataAlterada}T${item.horaAlterada}:00.000Z`;
        janela = new Date(janelaStr);
      }
      janela.setHours(janela.getHours() + 1);
      janelaStr = janela.toISOString();
      // console.log("entrou no existe ID");
      this.item = item;
      // console.log(janelaStr);
      // this.item["Destino 1"] = destino;
      // this.item[indexDestino] = janela;
      this.item.area = exists ? "EMB" : "EMBMR";
      this.item.tableName = "janelasTimeTable"
      this.item.dataAlterada = janelaStr.slice(0, 10); // "2024-04-23"
      this.item.horaAlterada = janelaStr.slice(11, 16); // "00:00"  
      this.item.lastUpdate = new Date();
      this.item.UpdateByUser = this.usuarioLogado.id;
      const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      // console.log(jsonArray)
      await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
        // console.log(response)
        await this.update();
        this.edit2 = false;
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
      });
    }
  }

  async reutilizarEXP(item: any) {
    // console.log(item)
    this.isLoading = true;
    this.dialogOpen = false;
    const currentDate = new Date().getTime();
    let janelaStr = '';
    let destino = '';
    let janela = new Date();
    if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
      destino = item["Destino 1"];
      janelaStr = item["JanelaDestino 1"];
      janela = new Date(janelaStr)
    } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
      destino = item["Destino 2"];
      janelaStr = item["JanelaDestino 2"];
      janela = new Date(janelaStr)
    } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
      destino = item["Destino 3"];
      janelaStr = item["JanelaDestino 3"];
      janela = new Date(janelaStr)
    }
    janela.setHours(janela.getHours() + 1);
    const exists = this.totalReservasEXP.some((existingItem: { ID: any; }) => existingItem.ID === item.ID);
    if (!exists) {
      this.item = item;
      this.item["Destino 1"] = destino;
      this.item["JanelaDestino 1"] = janela;
      this.item.area = "EXP";
      this.item.tableName = this.queryTimeTable;
      this.item.created = currentDate.toString();
      const itemsDataString = JSON.stringify(this.item);
      const modifiedString = itemsDataString.replace(/\\"/g, '"');
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      const modifiedJsonString = JSON.stringify(jsonObject);
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      const jsonArray = [jsonObject2];
    }
    else {
      this.dialogOpen = false;
      this.isLoading = false;
    }
  }

  async salvar() {
    // console.log(this.item)
    if ((this.item.dataAlterada && this.item.horaAlterada && this.item.motAlteracao && this.item.motAlteracao != 0) ||
      (this.item.dataAlterada === undefined && this.item.horaAlterada === undefined) ||
      (this.item.dataAlterada === null && this.item.horaAlterada === null)
    ) {
      if (this.item.idContainer && this.item.idContainer != "") {
        this.item.ID = this.item.idContainer;
      }
      if (this.item.idContainer && this.item.dataAlterada && this.item.horaAlterada ) {
        this.item.Janela = `${this.item.dataAlterada}T${this.item.horaAlterada}:00.000Z`;
      }
      if (this.item.Plate != this.atualPlate) {
        await this.calculoConsumo(this.item);
      }
      let dataHoraString;
      let dataHora;
      let formattedDate;
      try{
      dataHoraString = `${this.item.dataJanelaTimeTable}T${this.item.horaJanelaTimeTable}:00.000Z`;
      dataHora = new Date(dataHoraString);
      formattedDate = dataHora.toISOString();
      }catch{
        dataHoraString = `${this.item.dataJanelaDestino1}T${this.item.horaJanelaDestino1}:00.000Z`;
        dataHora = new Date(dataHoraString);
        formattedDate = dataHora.toISOString();
      }
      this.isLoading = true;
      this.item = {
        ...this.item,
        "ID": this.item.ID,
        "lastUpdate": new Date(),
        "UpdateByUser": this.usuarioLogado.id,
        // "dataJanelaDestino1": this.item.dataJanelaDestino1,
        // "horaJanelaDestino1": this.item.horaJanelaDestino1,
        "dataJanela": this.item.dataJanelaTimeTable,
        "horaJanela": this.item.horaJanelaTimeTable,
        // "dataJanelaTimeTable": this.item.dataAlterada ? this.item.dataAlterada : this.item.dataJanelaTimeTable,
        // "horaJanelaTimeTable": this.item.horaAlterada ? this.item.horaAlterada : this.item.horaJanelaTimeTable,
        "dataJanelaDestino1Alterada": this.item['Destino 1'] && this.item['Destino 1'].toUpperCase().includes('LCB') ? this.item.dataAlterada : undefined,
        "horaJanelaDestino1Alterada": this.item['Destino 1'] && this.item['Destino 1'].toUpperCase().includes('LCB') ? this.item.horaAlterada : undefined,
        // "dataJanelaDestino2": this.item.dataJanelaDestino2,
        // "horaJanelaDestino2": this.item.horaJanelaDestino2,
        "dataJanelaDestino2Alterada": this.item['Destino 2'] && this.item['Destino 2'].toUpperCase().includes('LCB') ? this.item.dataAlterada : undefined,
        "horaJanelaDestino2Alterada": this.item['Destino 2'] && this.item['Destino 2'].toUpperCase().includes('LCB') ? this.item.horaAlterada : undefined,
        "motAlteracao": this.item.motAlteracao ?? 0,
        // [this.item.janelaIndex]: formattedDate,
        // "dataJanela": dataHoraString,
        "JanelaDestino 1": this.item["JanelaDestino 1"] ? this.item["JanelaDestino 1"] : formattedDate,
        // "jan1": formattedDate,
        "Plate": this.item.Plate,
        "Volumes": this.item.Volumes,
        "idContainer": this.item.idContainer,
        "Transportadora": this.item.transportadora,
        'Fornecedor 1': this.item['Fornecedor 1'],
        'Fornecedores': this.item['Fornecedor 1'],
        "tableName": this.item.tableName ? this.item.tableName : this.queryTimeTable,
        [this.item.destinoIndex]: this.item.forn1
      }
      const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      // console.log(jsonArray)
      await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
        // console.log(response)
        if ((this.item.dataAlterada && this.item.horaAlterada && this.item.motAlteracao && this.item.motAlteracao != 0) && (this.item.area != "EMB" || this.item.area != "EMBMR")) {
          await this.AtualizaReservaEmbalagem(this.item);
        }
        await this.update();
        this.edit2 = false;
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
      });
    } else {
      this.campoTocado = true;
      alert("Formulario incompleto!")
      this.isLoading = false;
    }
  }

  formatarData(data: string): string {
    if (data) {
      const date1str = data.replace("Z", "");
      const dataObj = new Date(date1str)
      const dataFormatada = `${dataObj.toLocaleDateString('pt-BR')} ${dataObj.toLocaleTimeString('pt-BR')}`;
      return dataFormatada;
    } else {
      return 'sem data';
    }
  }

  convertToISOFormat(dateString: string): string | null {
    // Expressão regular para verificar o formato dd/MM/yyyy HH:mm:ss
    const dateTimeRegex = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/;
    if (!dateString.match(dateTimeRegex)) {
      return null; // Retorna null se a string não estiver no formato esperado
    }
    // Extrai os componentes da data e hora da string
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    // Cria um objeto Date com os componentes extraídos (mês é zero-indexado)
    const dateObject = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
    // Converte para formato ISO 8601
    const isoString = dateObject.toISOString();
    return isoString;
  }

  centerDialog(): void {
    const dialogRefElement = this.dialogRef?.containerInstance?.hostElement;
    if (dialogRefElement) {
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const dialogWidth = dialogRefElement.clientWidth;
      const dialogHeight = dialogRefElement.clientHeight;
      const top = Math.max(0, (windowHeight - dialogHeight) / 2);
      const left = Math.max(0, (windowWidth - dialogWidth) / 2);
      dialogRefElement.style.top = `${top}px`;
      dialogRefElement.style.left = `${left}px`;
    }
  }

  isValidDate(dateStr: string) {
    const date = new Date(dateStr);
    return !isNaN(date.getTime());
  }

  async getItemsContainer(): Promise<void> {
    const today = new Date();
    // this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos("items_Excel_Container", this.urlConsultaCompactada, 'All', "Janela", this.referenceDate, this.numDays5)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          // console.log(items)
          if (Array.isArray(items)) {
            this.itemsContainersPrev = items
            this.itemsContainers = this.filtrarItens(this.itemsContainersPrev);
            // console.log( this.itemsContainers)
            this.itemsContainers.forEach(item => {
              item.Volumes = item.Volumes ? item.Volumes : item.quantidadeMU
              // item.Plate = item.plate 
              item.Fornecedores = item.terminalOrigem
              item.Transportadora = item.transportador
              item.idContainer = item.idContainer
              try {
                let dataString = item["Janela"] ? item["Janela"] : (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["JanelaDestino 1"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["JanelaDestino 2"] :
                  (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["JanelaDestino 3"] : null;
                item.dataJanelaTimeTable = dataString.slice(0, 10); // "2024-04-23"
                item.horaJanelaTimeTable = dataString.slice(11, 16); // "00:00"  
              } catch {
                console.log("com erro")
                console.log(item)
              }
            });
            this.itemsContainersReuse = this.itemsContainers.filter(item => {
              return (item.destinoApos && item.destinoApos.includes("REUTILIZAR LCB"));
            });
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  formatarDataChegada(data: string): string {
    // Verifica se a data está no primeiro formato (MM/DD/YYYY HH:mm:ss AM/PM)
    if (/^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{2}:\d{2} (AM|PM)$/.test(data)) {
      // Separa os componentes da data
      const partes = data.split(/[\s/:]/);
      // Converte para o formato desejado (DD/MM/YYYY HH:mm:ss)
      const novaData = `${partes[1]}/${partes[0]}/${partes[2]} ${partes[3]}:${partes[4]}:${partes[5]}`;
      return novaData;
    }
    // Se estiver no segundo formato ou em outro formato, retorna a data original
    return data;
  }

  converterStringParaData(dataString: string): Date | null {
    dataString = this.formatarDataChegada(dataString);
    // Divide a string de data em partes separadas
    const partes = dataString.split(/[\/\s:]/);
    // Verifica se há 6 partes (ano, mês, dia, hora, minuto, segundo)
    if (partes.length === 6) {
      // Obtém os componentes individuais da data
      const ano = parseInt(partes[2], 10);
      const mes = parseInt(partes[1], 10) - 1; // Os meses em JavaScript são baseados em zero (janeiro é 0)
      const dia = parseInt(partes[0], 10);
      const hora = parseInt(partes[3], 10);
      const minuto = parseInt(partes[4], 10);
      const segundo = parseInt(partes[5], 10);
      // Cria um objeto Date com os componentes da data
      const data = new Date(ano, mes, dia, hora, minuto, segundo);
      return data;
    } else {
      // Se o formato da string de data não estiver correto, retorne null
      return null;
    }
  }

  async getItemsFromDynamoDB(): Promise<void> {
    const today = new Date();
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.query, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays5)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.items = items
            this.totalItensJetta = this.filtrarItens(this.items);
            this.totalItensJetta.forEach(item => {
              let dataString = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["JanelaDestino 1"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["JanelaDestino 2"] :
                (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["JanelaDestino 3"] : (item["destino"] && item["destino"].toUpperCase().includes('LCB')) ? item["Janela"] : new Date().toDateString();
              try {
                item.dataJanelaTimeTable = dataString.slice(0, 10); // "2024-04-23"
                item.horaJanelaTimeTable = dataString.slice(11, 16); // "00:00"  
              } catch {
                console.log("com erro");
              }
            })
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getItemsFromJanelasReservadas(): Promise<void> {
    const today = new Date();

    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos("janelasTimeTable", this.urlConsultaCompactada, 'All', "dataJanela", this.referenceDate, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            // console.log(items)
            this.itemsReserva = items
            this.itemsReserva.forEach(item => {
              item.dataJanelaTimeTable = item.dataJanela;
              item.horaJanelaTimeTable = item.horaJanela;
            })
            this.totalReservas = this.filtrarItens(this.itemsReserva);
            // console.log(this.totalReservas)
            this.totalReservasRECCONT = []
            this.totalReservasRECCONT = this.totalReservas.filter(item => {
              return (item.area == 'RECCONT');
            })
            this.totalReservasRECSIDER = []
            this.totalReservasRECSIDER = this.totalReservas.filter(item => {
              return (item.area == 'RECSIDER');
            })
            // console.log(this.totalReservasRECSIDER)
            this.totalReservasEMB = []
            this.totalReservasEMB = this.totalReservas.filter(item => {
              return (item.area == 'EMB');
            })
            this.totalReservasEMBMR = []
            this.totalReservasEMBMR = this.totalReservas.filter(item => {
              return (item.area == 'EMBMR');
            })
            this.totalReservasEXP = []
            this.totalReservasEXP = this.totalReservas.filter(item => {
              return (item.area == 'EXP');
            })
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  compararDatas(data1: string, data2: string) {
    // console.log(data1)
    // console.log(data2)
    const dataFormatada1 = new Date(data1).toLocaleDateString();
    const dataFormatada2 = new Date(data2).toLocaleDateString();
    // console.log(dataFormatada1)
    // console.log(dataFormatada2)
    return dataFormatada1 === dataFormatada2;
  }

  compararSubstrings(string1: string, string2: string, comprimentoMinimo: number) {
    // Converte ambas as strings para minúsculas para fazer uma comparação sem diferenciação entre maiúsculas e minúsculas
    // console.log(string1)
    // console.log(string2)
    const substrings1 = string1.toLowerCase().split(/\s+/); // Divida por espaços
    const substrings2 = string2.toLowerCase().split(/\s+/); // Divida por espaços

    // Filtra substrings com menos de comprimentoMinimo caracteres
    const substringsFiltradas1 = substrings1.filter(substring => substring.length > comprimentoMinimo);
    const substringsFiltradas2 = substrings2.filter(substring => substring.length > comprimentoMinimo);

    // Verifica se há alguma substring comum
    const temSubstringsComuns = substringsFiltradas1.some(substring1 =>
      substringsFiltradas2.some(substring2 => substring1.includes(substring2) || substring2.includes(substring1))
    );
    return temSubstringsComuns;
  }

  filtrarItens(itens: any[]): any[] {
    // console.log(itens)
    // const hoje = new Date(); // Obtém a data atual
    let dataHoraString: string;
    // let date1str;
    // let date2str;
    let dataJanelaDestino: Date;
    let destinoLCB2 = false;
    this.dataExibir.setHours(0, 0, 0, 0); // Define as horas para 00:00:00
    // console.log(this.dataExibir)
    return itens.filter(item => {
      // Verifica se "Destino 2" contém "LCB"
      if ((item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) || (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) ||
        (item['destino'] && item['destino'].toUpperCase().includes('LCB')) ||
        (item['Fornecedor 1'] && item['Fornecedor 1'].toUpperCase().includes('LCB'))) {
        if (item.dataJanelaDestino1Alterada) {
          dataHoraString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000`;
        }
        else if (item.dataJanelaDestino2Alterada) {
          dataHoraString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000`;
        }
        else if (item.dataAlterada && item.horaAlterada) {
          dataHoraString = `${item.dataAlterada}T${item.horaAlterada}:00.000`;
        }
        else if (item.dataJanelaTimeTable) {
          dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000`;
        }
        else if (item.dataJanela && item.horaJanela) {
          dataHoraString = `${item.dataJanela}T${item.horaJanela}:00.000`;
        }
        else if (item.dataJanela && item.horario) {
          dataHoraString = `${item.dataJanela}T${item.horario}:00.000`;
        }
        // console.log(dataHoraString)
        else if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB') && item['JanelaDestino 1'] && item['JanelaDestino 1'] != '') {
          // destinoLCB2 = item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB');
          dataHoraString = item['JanelaDestino 1'].replace("Z", "");
        } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB') && item['JanelaDestino 2'] && item['JanelaDestino 2'] != '') {
          dataHoraString = item['JanelaDestino 2'].replace("Z", "");
        } else if (item['Janela']) {
          dataHoraString = item['Janela'].replace("Z", "");
        }
        destinoLCB2 = (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) || (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) ||
          (item['destino'] && item['destino'].toUpperCase().includes('LCB'));
        dataJanelaDestino = new Date(dataHoraString);
        dataJanelaDestino.setHours(0, 0, 0, 0);
        return dataJanelaDestino.getTime() === this.dataExibir.getTime();
      }
      else {
        return false; // Se "Destino 2" não contém "LCB", o item não é incluído
      }
    });
  }


  async compareDatesSemHoras(date1str: string, date2str: string): Promise<number> {
    // date1str = date1str.replace("Z", "");
    // console.log(date1str)
    // console.log(date2str)
    if (date1str !== undefined) {
      try {
        // await this.retiraeZ(date1str); //= date1str.replace("Z", "");
        date1str = date1str.replace("Z", "");
        // date2str = date2str.replace("Z", "");
      } catch {
        // console.log(date1str)
      }
    }
    const date1 = this.removeTimeFromDate(new Date(date1str));
    const date2 = this.removeTimeFromDate(new Date(date2str));
    const timestamp1 = date1.getTime();
    const timestamp2 = date2.getTime();
    if (timestamp1 < timestamp2) {
      // console.log(date1)
      // console.log(date2)
      // console.log("retorno -1")
      return -1; // date1 é anterior a date2
    } else if (timestamp1 > timestamp2) {
      // console.log(date1)    
      // console.log(date2)
      // console.log("retorno 1")
      return 1; // date1 é posterior a date2
    } else {
      // console.log(date1)
      // console.log(date2)
      // console.log("retorno 0")
      return 0; // date1 é igual a date2
    }
  }

  removeTimeFromDate(date: Date): Date {
    date.setHours(0, 0, 0, 0);
    return date;
  }

  parseDateString(dateStr: string) {
    if (!dateStr.includes("T")) {
      dateStr += "T00:00:00";
    }
    return new Date(dateStr);
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  async getProgramacaoInterplantasFromDynamoDB(): Promise<void> {
    this.totalJanelasInterplantasObj = 0;
    const currentDate = new Date();
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.queryInterplantas, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, 2)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          // console.log(items)
          if (Array.isArray(items)) {
            this.viagensInterplantasFinalizadas = [];
            this.itemsInterplantas = items
            this.itemsInterplantas = this.filtrarItens(this.itemsInterplantas);
            this.itemsInterplantas.forEach(item => {
              item['JanelaDestino 1']= item['Janela'];
              let dataString = item['JanelaDestino 1'];
              try {
                item.dataJanelaTimeTable = dataString.slice(0, 10); // "2024-04-23"
                item.horaJanelaTimeTable = dataString.slice(11, 16); // "00:00"  
              } catch {
                console.log("com erro")
              }
            })
            this.viagensInterplantasFinalizadas = await items
              .filter(item =>
                item["Janela"] >= this.dataFiltraInterplantas && item.JanelaConcluida > 0)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getItemsFromArgentina(maxRetries: number = 3): Promise<void> {
    const today = new Date();
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const response: any = await new Promise(async (resolve, reject) => {
          (await this.dynamodbService.getItemsVolumesAltos(this.query4, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays15)).subscribe(
            (res: any) => resolve(res),
            (error: any) => reject(error)
          );
        });
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.argentina = items;
              // console.log(this.argentina );
              this.itemsArg = this.filtrarItens(this.argentina);
              // console.log(this.itemsArg)
              this.itemsArg.forEach(item => {
                let dataString = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["JanelaDestino 1"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["JanelaDestino 2"] :
                  (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["JanelaDestino 3"] : (item["destino"] && item["destino"].toUpperCase().includes('LCB')) ? item["Janela"] : item["dataJanela"];
                try {
                  item.dataJanelaTimeTable = dataString.slice(0, 10); // "2024-04-23"
                  item.horaJanelaTimeTable = dataString.slice(11, 16); // "00:00"  
                } catch {
                  console.log("com erro")
                }
              })
              return; // Saia da função se bem-sucedido
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      } catch (error) {
        console.error(`Attempt ${attempt} failed:`, error);
      }
      if (attempt < maxRetries) {
        // console.log(`Retrying... (${attempt}/${maxRetries})`);
      }
    }
    console.error('All attempts to fetch items from Argentina failed.');
  }


  async getItemsFromVW(): Promise<void> {
    const today = new Date();
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.queryVW, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, 2)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            const auxItemsVW = items
            this.itemsVW = this.filtrarItens(auxItemsVW);
            this.itemsVW.forEach(item => {
              let dataString = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["JanelaDestino 1"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["JanelaDestino 2"] :
                (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["JanelaDestino 3"] : (item["destino"] && item["destino"].toUpperCase().includes('LCB')) ? item["Janela"] : new Date().toDateString();
              try {
                item.dataJanelaTimeTable = dataString.slice(0, 10); // "2024-04-23"
                item.horaJanelaTimeTable = dataString.slice(11, 16); // "00:00"  
              } catch {
                console.log("com erro")
              }
            })
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getCarriersFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.query2, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carrier = items.map(item => ({ ...item, checked: false }));
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
              // Forçar detecção de alterações após atualizar os dados
              this.cdr.detectChanges();
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async deleteItemTabelaExtraLCB(item: any): Promise<void> {
    // const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
    let tableSalvar = '';
    // if (confirmacao) {
    this.isLoading = true;
    if (item.origemExtraLCB) {
      await this.dynamodbService.deleteItem(item.ID, this.urlAtualiza, this.queryDiretasExtrasLCB).subscribe(
        async response => {
          console.log("Deletado da tabela: " + tableSalvar)
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    } else if (item.origemDiretoLCB) {
      await this.resetaValoresDiretosLCB(item);
    }
    // }
  }

  async resetaValoresDiretosLCB(item: any) {
    // const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
    //   // Verifica se o usuário confirmou a ação
    // if (confirmacao) {
    this.isLoading = true;
    this.item.tableName = this.queryDiretasLCB;
    this.item = {
      ...item,
      "lastUpdate": new Date(),
      "placa": "",
      "quantidadeMU": '0'
    }
    // console.log([this.item])
    try {
      await this.dynamodbService.salvar([this.item], this.queryDiretasLCB, this.urlAtualiza).subscribe(async response => {
      }, error => {
        console.log(error);
      });
    } catch (error) {
      console.log(error);
    }
    // }
  }

  async deleteItem(Item: any): Promise<void> {
    const companyUsuarioLogado = this.usuarioLogado.company?.toLowerCase();
    const transportadoraItem = Item.Transportadora?.toLowerCase();
    // console.log(item.Transportadora)
    // console.log(this.usuarioLogado.company)
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && transportadoraItem.includes(companyUsuarioLogado) && (Item.area == "EMB" || Item.area == "EMBMR"))) {
      const confirmacao = window.confirm("Tem certeza que deseja excluir esta viagem?");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.isLoading = true;
        const ID = Item.ID;
        await this.dynamodbService.deleteItem(ID, this.urlAtualiza, Item.tableName).subscribe(
          async response => {
            if (Item.origemExtraLCB || Item.origemDiretoLCB) {
              await this.deleteItemTabelaExtraLCB(Item);
            }
            await this.ngOnInit();
            this.dialogOpen = false;
            this.isLoading = false;
          },
          error => {
            // Lógica para lidar com erros durante a deleção do item
          }
        );
      }
    } else {
      const confirmacao = window.confirm("Usuário não autorizado!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.dialogOpen = false;
      }
    }
  }

  async FinalizarViagem(item: any) {
    const confirmacao = window.confirm("Tem certeza que deseja finalizar esta viagem?");
    let propertyName = "";
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      //console.log(item)
      var PassoF: any = []
      var PassoD: any = []
      for (let i = 1; i < 5; i++) {
        if (item['Fornecedor ' + i]) {
          PassoF[i] = 1;
        } else {
          PassoF[i] = 0;
        }
        // //console.log('PassoF[' + i + '] = ' + PassoF[i])
      }
      for (let i = 1; i < 5; i++) {
        if (item['Destino ' + i]) {
          PassoD[i] = 1;
        } else {
          PassoD[i] = 0;
        }
        // //console.log('PassoD[' + i + '] = ' + PassoD[i])
      }

      if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
        propertyName = "FinalizacaoManualDestino1";
      } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
        propertyName = "FinalizacaoManualDestino2";
      };

      const body = [{
        ...item, // Mantém as chaves existentes
        "ID": item.ID,
        "FinalizadaManual": true,
        [propertyName]: true,
        'Passo Fornecedor1': PassoF[1],
        'Passo Fornecedor2': PassoF[2],
        'Passo Fornecedor3': PassoF[3],
        'Passo Fornecedor4': PassoF[4],
        'Passo Destino1': PassoD[1],
        'Passo Destino2': PassoD[2],
        'Passo Destino3': PassoD[3],
        'Passo Destino4': PassoD[4],
      }];

      //nao usa a query, ele manda a time table no item
      await this.dynamodbService.salvar(body, item.tableName, this.urlAtualiza).subscribe(async response => {
        // Atualiza o item no banco de dados com sucesso
        await this.update();
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
        // Lidar com o erro ao atualizar o item no banco de dados
      });
    }
  }


  sortBy(column: string) {
    if (this.sortColumn === column) {
      // Reverse the sort direction
      this.sortDirection *= -1;
    } else {
      // Set the new sort column and reset the sort direction
      this.sortColumn = column;
      this.sortDirection = 1;
    }
    this.mergedData.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const valueA = a[this.sortColumn];
      const valueB = b[this.sortColumn];
      if (valueA < valueB) {
        return -1 * this.sortDirection;
      } else if (valueA > valueB) {
        return 1 * this.sortDirection;
      } else {
        return 0;
      }
    });
  }

  cancel(): void {
    this.edit2 = false;
    this.dialogOpen = false;
  }

  async getUserLogado() {
    this.usuarioLogado = await this.servicoAutenticacao.obterUsuarioLogado()
    await this.enableFields();
    await this.enableFieldsTCM();
    await this.enableFieldsLOTS();
    await this.enableFieldsJSL();
    await this.enableFieldsJSLARG();
    await this.enableFieldsJSLVW();
  }

  navigateTo(route: string): void {
    this.router.navigateByUrl(route);
  }

  removeDuplicados(array1: any[], array2: any[]) {
    // Cria conjuntos dos IDs dos arrays
    const ids1 = new Set(array1.map(item => item.ID));
    const ids2 = new Set(array2.map(item => item.ID));
    // console.log(array1)
    // Encontra IDs duplicados
    const duplicados = new Set([...ids1].filter(id => ids2.has(id)));
    // console.log(duplicados)
    const arrayFiltrado = array1.filter(item => !duplicados.has(item.ID));
    // console.log(arrayFiltrado)
    return arrayFiltrado;
  }

  async exportToExcel(data: any[], area: string): Promise<void> {
    var columnOrder: any[] = [];
    // console.log(data);
    if (data.length === 0) {
      //console.log('Nenhum dado para exportar.');
      return;
    }
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      columnOrder = [
        'ID',
        'Plate',
        'Transport Type',
        'Transportadora',
        'Fornecedores',
        'Volumes',
        'Registro',
        'Destino entrega',
        'Data janela entrega Original',
        'Hora janela entrega Original',
        'Data janela entrega Alterada',
        'Hora janela entrega Alterada',
        'Motivo da Alteração',
        'data Chegada',
        'hora Chegada',
        'data Entrada',
        'hora Entrada',
        'data Saida',
        'hora Saida',
        'statusChegada',
        'FinalizadaManual',
      ];
    } else {
      columnOrder = [
        'ID',
        'Plate',
        'Transport Type',
        'Transportadora',
        'Fornecedores',
        'Volumes',
        'Registro',
        'Destino entrega',
        'Data janela entrega Original',
        'Hora janela entrega Original',
        'Data janela entrega Alterada',
        'Hora janela entrega Alterada',
        'Motivo da Alteração',
        'data Chegada',
        'hora Chegada',
        'data Entrada',
        'hora Entrada',
        'data Saida',
        'hora Saida',
        'statusChegada'
      ];
    }
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    // Adicione o cabeçalho à planilha e aplique formatação
    const headerRow = worksheet.addRow(columnOrder);
    headerRow.font = { bold: true };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'C0C0C0' }
    };

    // Adicione bordas ao cabeçalho
    headerRow.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };
    for (const hora of data) {
      // Verifica se a área passada existe e é um array
      if (hora[area] && Array.isArray(hora[area])) {
        for (const item of hora[area]) {
          // for (const item of hora[area]) {
          // data.forEach(async (hora, index) => {
          // console.log(item)
          //   await hora[area].forEach((item: { [x: string]: any; }) => {
          if (item['idContainer'] && item['idContainer'] != "") {
            // console.log("passou no if")
            //console.log(item)
            const dataHoraString = item['Janela'] ? item['Janela'] : item['Destino 1'] && item['Destino 1'].includes('LCB') ? item['JanelaDestino 1'] :
              item['Destino 2'] && item['Destino 2'].includes('LCB') ? item['JanelaDestino 2'] : null;
            // Extrair a data e a hora da string
            try {
              item['dataJanelaTimeTable'] = dataHoraString.slice(0, 10); // "2024-04-23"
              item['horaJanelaTimeTable'] = dataHoraString.slice(11, 16); // "00:00"
            } catch {
              console.log('Erro na data')
              console.log(item)
            }
            item['Destino entrega'] = item['Destino 1']
            item['Data janela entrega Original'] = item['dataJanelaTimeTable']
            item['Hora janela entrega Original'] = item['horaJanelaTimeTable']
            item['Data janela entrega Alterada'] = item['dataAlterada']
            item['Hora janela entrega Alterada'] = item['horaAlterada']
          }
          else if (item['dataJanelaTimeTable'] && item['horaJanelaTimeTable'] && item['Destino 1'].includes('LCB')) {
            try{
            item['dataJanelaTimeTable'] = item['dataJanelaTimeTable']; // "2024-04-23"
            item['horaJanelaTimeTable'] = item['horaJanelaTimeTable']; // "00:00"
            item['Destino entrega'] = item['Destino 1']
            // item['Data janela entrega'] = item['dataJanelaDestino1']
            // item['Hora janela entrega'] = item['horaJanelaDestino1']
            item['Data janela entrega Original'] = item['dataJanelaTimeTable']
            item['Hora janela entrega Original'] = item['horaJanelaTimeTable']
            item['Data janela entrega Alterada'] = item['dataJanelaDestino1Alterada']
            item['Hora janela entrega Alterada'] = item['horaJanelaDestino1Alterada']
            }catch{
            console.log(item)
            console.log(item['JanelaDestino 1'])
            }
          }
          else if (!item['dataJanelaDestino1'] && item['Destino 1'] && item['Destino 1'].includes('LCB')) {
            const dataHoraString = item['JanelaDestino 1'];
            try{
            item['dataJanelaTimeTable'] = dataHoraString.slice(0, 10); // "2024-04-23"
            item['horaJanelaTimeTable'] = dataHoraString.slice(11, 16); // "00:00"
            item['Destino entrega'] = item['Destino 1']
            // item['Data janela entrega'] = item['dataJanelaDestino1']
            // item['Hora janela entrega'] = item['horaJanelaDestino1']
            item['Data janela entrega Original'] = item['dataJanelaTimeTable']
            item['Hora janela entrega Original'] = item['horaJanelaTimeTable']
            item['Data janela entrega Alterada'] = item['dataJanelaDestino1Alterada']
            item['Hora janela entrega Alterada'] = item['horaJanelaDestino1Alterada']
            }catch{
            console.log(item)
            console.log(item['JanelaDestino 1'])
            }
          } else if (!item['dataJanelaDestino2'] && item['Destino 2'] && item['Destino 2'].includes('LCB')) {
            const dataHoraString = item['JanelaDestino 2'];
            item['dataJanelaDestino2'] = dataHoraString.slice(0, 10); // "2024-04-23"
            item['horaJanelaDestino2'] = dataHoraString.slice(11, 16); // "00:00"
            item['Destino entrega'] = item['Destino 2']
            // item['Data janela entrega'] = item['dataJanelaDestino2']
            // item['Hora janela entrega'] = item['horaJanelaDestino2']
            item['Data janela entrega Original'] = item['dataJanelaDestino2']
            item['Hora janela entrega Original'] = item['horaJanelaDestino2']
            item['Data janela entrega Alterada'] = item['dataJanelaDestino2Alterada']
            item['Hora janela entrega Alterada'] = item['horaJanelaDestino2Alterada']
          }
          else {
            if (item['Destino 1'] && item['Destino 1'].includes('LCB')) {
              item['Destino entrega'] = item['Destino 1']
              // item['Data janela entrega'] = item['dataJanelaDestino1']
              // item['Hora janela entrega'] = item['horaJanelaDestino1']
              item['Data janela entrega Original'] = item['dataJanelaTimeTable']
              item['Hora janela entrega Original'] = item['horaJanelaTimeTable']
              item['Data janela entrega Alterada'] = item['dataJanelaDestino1Alterada']
              item['Hora janela entrega Alterada'] = item['horaJanelaDestino1Alterada']
            } else if (item['Destino 2'] && item['Destino 2'].includes('LCB')) {
              item['Destino entrega'] = item['Destino 2']
              // item['Data janela entrega'] = item['dataJanelaDestino2']
              // item['Hora janela entrega'] = item['horaJanelaDestino2']
              item['Data janela entrega Original'] = item['dataJanelaDestino2']
              item['Hora janela entrega Original'] = item['horaJanelaDestino2']
              item['Data janela entrega Alterada'] = item['dataJanelaDestino2Alterada']
              item['Hora janela entrega Alterada'] = item['horaJanelaDestino2Alterada']
            }
          }
          if (item.motAlteracao && item.motAlteracao != 0) {
            item['Motivo da Alteração'] = this.opcoesMotivo.find(opcao => opcao.valor == item.motAlteracao)?.descricao;
          }
          if (item['ChegadaLCB'] && item['ChegadaLCB'] != "") {
            const chegadaString = item['ChegadaLCB'];
            item['data Chegada'] = chegadaString.slice(0, 10); // "2024-04-23"
            item['hora Chegada'] = chegadaString.slice(11, 16); // "00:00"
          }
          if (item['EntradaLCB'] && item['EntradaLCB'] != "") {
            const entradaString = item['EntradaLCB'];
            item['data Entrada'] = entradaString.slice(0, 10); // "2024-04-23"
            item['hora Entrada'] = entradaString.slice(11, 16); // "00:00"
          }
          if (item['SaidaLCB'] && item['SaidaLCB'] != "") {
            const saidaString = item['SaidaLCB'];
            item['data Saida'] = saidaString.slice(0, 10); // "2024-04-23"
            item['hora Saida'] = saidaString.slice(11, 16); // "00:00"
          }
          if (item['Volumes']) {
            const vol = item['Volumes'];
            item['Volumes'] = parseFloat(vol);
          }
          if (item['SequenciaLCB']) {
            const seq = item['SequenciaLCB'];
            item['Registro'] = parseFloat(seq);
          }
          const row = columnOrder.map(column => item[column]);
          const dataRow = worksheet.addRow(row);
          // Adicione bordas aos dados
          dataRow.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        };
      };
    }
    // Salve o arquivo modificado

    let outputFilePath = '';
    if (this.filtroacionado) {
      let parsedDate = parseISO(this.dataExibirPre.toString());
      const auxDate = format(parsedDate, "dd/MM/yyyy");
      outputFilePath = 'time_table' + area + auxDate + '.xlsx';
    } else {
      outputFilePath = 'time_table' + area + this.startDate + '.xlsx';
    }
    const buffer = await workbook.xlsx.writeBuffer();
    const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    fs.saveAs(blobData, outputFilePath);

    // Exiba um alerta para o usuário baixar o arquivo
    alert('Clique para baixar o arquivo.');
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      this.isCarrierEnabled = false;
    }
  }

  enableFieldsTCM() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "TCM")) {
      this.isCarrierTCMEnabled = false;
    }
  }

  enableFieldsJSL() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL")) {
      this.isCarrierJSLEnabled = false;
    }
  }

  enableFieldsJSLARG() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-ARG")) {
      this.isCarrierJSLARGEnabled = false;
    }
  }

  enableFieldsLOTS() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "LOTS")) {
      this.isCarrierLOTSEnabled = false;
    }
  }

  enableFieldsJSLVW() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-VW")) {
      this.isCarrierJSLVWEnabled = false;
    }
  }


}


